import i18n from "../../sipli-fleet-core/translationService";
import sharedEnTranslation from "../../sipli-fleet-core/translationService/locales/en.json";
import sharedItTranslation from "../../sipli-fleet-core/translationService/locales/it.json";
import localEnTranslation from "./locales/en.json";
import localItTranslation from "./locales/it.json";

i18n.addResourceBundle(
  "en",
  "translation",
  {
    ...sharedEnTranslation,
    ...localEnTranslation,
  },
  false,
  true,
);

i18n.addResourceBundle(
  "it",
  "translation",
  {
    ...sharedItTranslation,
    ...localItTranslation,
  },
  false,
  true,
);

export default i18n;
